import { BaseRecord } from "@refinedev/core";

export enum PaymentRequestStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export enum PaymentRequestPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  URGENT = "URGENT",
}

export enum Currency {
  ETB = "ETB",
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
}

export interface BankAccountDetails {
  bank: string;
  accountNo: string;
}

export interface PaymentDetails {
  voucherNumber?: string;
  paidAmount?: number;
  paymentDate?: Date;
  method?: string;
  reference?: string;
}

export interface Attachment {
  fileId: string;
  originalName: string;
  mimeType: string;
  size: number;
  category?: string;
}

export interface PaymentRequest extends BaseRecord {
  id: string;
  invoiceId: string;
  poNo: string;
  receivingNo: string;
  supplierId: string;
  supplierName: string;
  attachments?: Attachment[];
  amount: number;
  currency: Currency;
  exchangeRate: number;
  dueDate: Date;
  priority: PaymentRequestPriority;
  bankAccountDetails: BankAccountDetails;
  status: PaymentRequestStatus;
  payment?: PaymentDetails;
  createdBy?: string;
  updatedBy?: string;
  submittedBy?: string;
  submittedAt?: Date;
  completedBy?: string;
  completedAt?: Date;
  cancelledBy?: string;
  cancelledAt?: Date;
  teamId?: string;
  tags?: string[];
  notes?: string;
  externalWorkflow?: Record<string, any>;
  flowCaseId?: string;
  flowCaseNumber?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreatePaymentRequestInput {
  invoiceId: string;
  amount?: number;
  currency?: Currency;
  exchangeRate?: number;
  priority?: PaymentRequestPriority;
  bankAccountDetails: BankAccountDetails;
  attachments?: Attachment[];
  notes?: string;
  tags?: string[];
}

export interface UpdatePaymentRequestInput {
  invoiceId?: string;
  poNo?: string;
  receivingNo?: string;
  supplierId?: string;
  supplierName?: string;
  amount?: number;
  currency?: Currency;
  exchangeRate?: number;
  dueDate?: Date;
  priority?: PaymentRequestPriority;
  bankAccountDetails?: BankAccountDetails;
  status?: PaymentRequestStatus;
  payment?: PaymentDetails;
  attachments?: Attachment[];
  notes?: string;
  tags?: string[];
}

export interface SubmitPaymentRequestInput {
  paymentRequestId?: string;
  paymentRequestData?: CreatePaymentRequestInput;
}

export interface CompletePaymentRequestPaymentInput {
  paymentRequestId: string;
  payment: PaymentDetails;
}

export interface CancelPaymentRequestInput {
  paymentRequestId: string;
  reason?: string;
}

export interface FailPaymentRequestInput {
  paymentRequestId: string;
  reason?: string;
}
